import { isShowEvent } from 'src/config/event/utils';
import { SampleGptButton } from '../SampleGptButton';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/gpt/games';
import { LuckyPigeonEventIcon } from 'src/config/assets/gptEventIcons/LuckyPigeonEventIcon';

export const BirdGameButton = () => {
  const isGptGameEvent = isShowEvent('GPT_GAMES');

  return (
    <GPTGameLauncher
      gameName="birdGame"
      renderButton={({ Icon, ...props }) => (
        <SampleGptButton Icon={isGptGameEvent ? LuckyPigeonEventIcon : Icon} {...props} />
      )}
      authOnly={false}
    />
  );
};
